import CustomCardPurchasePage from './CustomCardPurchasePage.vue';
import GiftCardsPage from './GiftCardsPage.vue';
import GiftCardProductPage from './product/GiftCardProductPage.vue';

export default [
  {
    path: '/custom-cards/:id',
    name: 'custom-card-purchase',
    component: CustomCardPurchasePage,
    meta: {
      title: 'Carte cadeau personnalisée'
    }
  },
  {
    path: '/cards/:category',
    name: 'gift-cards-category',
    component: GiftCardsPage,
    meta: {
      title: 'Cartes cadeaux'
    }
  },
  {
    path: '/cards/:category/:slug',
    name: 'gift-card-product',
    component: GiftCardProductPage,
    meta: {
      title: 'Carte cadeau'
    }
  }
];
